import { useMutation, useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, MutationConfig, QueryConfig } from '@/lib/react-query';
import { Business } from '@/features/business';
import { BusinessesResponse } from '@/features/businesses';
type UseBusinessOptions = {
  search?: string;
};
export const getBusiness = ({ search }: UseBusinessOptions): Promise<BusinessesResponse> => {
  return axios.get(`/business/not-subscribed`);
};

type UseGetBusinessOptions = {
  config?: MutationConfig<typeof getBusiness>;
};
export const useGetBusinessNotSubscribed = ({ config }: UseGetBusinessOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getBusiness,
  });
};
